<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <!-- Vrsta stavke -->
        <div class="row">
            <div class="col-lg-4 col-12" *ngIf="fcd && fcd['CenaUValuti'] && !fcd['CenaUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist 
                            #autofocus
                            [ModelName]="'vrstastavki'" 
                            [GetName]="'get'" 
                            [ModelProperty]="'Sifra,Naziv'"
                            [OrderBy]="'Naziv'" 
                            [AllowAddNew]="true" 
                            [AllowEdit]="true"
                            formControlName="VrstaStavkiID" 
                            [Label]="'FAKDOKUMENTSTAVKA.VRSTASTAVKI.SINGULAR'"
                            (OnItemSelected)="onVrstaStavkiSelect($event)"
                            [Width]="'xl'"
                            [Position]="'left'"
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.VrstaStavkiID.invalid">
                            <span *ngFor="let validation of errorMessages.VrstaStavkiID">
                              <span class="error-message" *ngIf="fc.VrstaStavkiID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-12" *ngIf="fcd && fcd['CenaUValuti'] && fcd['CenaUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist 
                            #autofocus
                            [ModelName]="'vrstastavki'" 
                            [GetName]="'get'" 
                            [ModelProperty]="'Sifra,Naziv'"
                            [OrderBy]="'Naziv'" 
                            [AllowAddNew]="true" 
                            [AllowEdit]="true"
                            formControlName="VrstaStavkiID" 
                            [Label]="'FAKDOKUMENTSTAVKA.VRSTASTAVKI.SINGULAR'"
                            (OnItemSelected)="onVrstaStavkiSelect($event)"
                            [Width]="'xl'"
                            [Position]="'left'"
                            [TableColumns]="[{ name: 'Sifra', label: 'VRSTASTAVKI.SIFRA.SINGULAR', visible: true, canHide: false, width: '10%'  }
                                , { name: 'Naziv', label: 'VRSTASTAVKI.OPIS.SINGULAR', visible: true, canHide: false, width: '65%' }
                                , { name: 'RobaUsluga', label: 'VRSTASTAVKI.ROBAUSLUGA.SINGULAR', visible: true, canHide: false, width: '10%' }
                                , { name: 'JedinicaMere', label: 'VRSTASTAVKI.JEDINICAMERE.SINGULAR', visible: true, canHide: false, width: '15%' }]">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.VrstaStavkiID.invalid">
                            <span *ngFor="let validation of errorMessages.VrstaStavkiID">
                              <span class="error-message" *ngIf="fc.VrstaStavkiID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1 col-12">
                <div class="form-group row">
                    <!-- <div class="col-md-12">
                        <yt-input 
                        [Type]="'text'" 
                        [Label]="'FAKDOKUMENTSTAVKA.ROBAUSLUGA.SINGULAR'" 
                        formControlName="RobaUsluga"   
                        [MaxLength]="1"                     
                        >                    
                        </yt-input>
                    </div>
                    <div class="form-error" *ngIf="submitted && fc.RobaUsluga.invalid">
                        <span *ngFor="let validation of errorMessages.RobaUsluga">
                          <span class="error-message" *ngIf="fc.RobaUsluga.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div> -->
                    <yt-radio-buttons-group
                        [Items]="rbItems"
                        formControlName="RobaUsluga">
                    </yt-radio-buttons-group>
                    <div class="form-error" *ngIf="submitted && fc.RobaUsluga.invalid">
                        <span *ngFor="let validation of errorMessages.RobaUsluga">
                        <span class="error-message" *ngIf="fc.RobaUsluga.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- Opis -->
            <div class="col-lg-5 col-12">
            <div class="form-group row">
                <div class="col-md-12">
                    <yt-text-area 
                    #txtOpis
                    [MaxLength]="1000" 
                    name="txtNapomena" 
                    formControlName="Opis"
                    [Label]="'FAKDOKUMENTSTAVKA.OPIS.SINGULAR'" 
                    [Height]="1"
                    [ngClass]="{'is-invalid': submitted && fc.Opis.invalid}">
                  </yt-text-area>
                    <div class="form-error" *ngIf="submitted && fc.Opis.invalid">
                        <span *ngFor="let validation of errorMessages.Opis">
                          <span class="error-message" *ngIf="fc.Opis.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                </div>
            </div>
            </div>
            <!-- Tarifa -->
            <div class="col-lg-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist 
                            [ModelName]="'tarifa'" 
                            [GetName]="'getFlat'"                                 
                            [GetParameters]="Parameters && Parameters.size > 0 ? Parameters.get(0) : null"
                            [ModelProperty]="'SiriOpis'"
                            [OrderBy]="'Sifra,Naziv'" 
                            [AllowAddNew]="false" 
                            formControlName="TarifaID" 
                            [Label]="'FAKDOKUMENTSTAVKA.TARIFA.SINGULAR'"
                            (OnItemSelected)="onTarifaSelect($event)"
                            [Width]="'490px'"
                            [Position]="'right'"
                            [ngClass]="{'is-invalid': submitted && fc.TarifaID.invalid}"
                            (GetItems)="TarifaGetItems($event)"
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
                            <span *ngFor="let validation of errorMessages.TarifaID">
                                <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        <!--[GetParameters]= "[{ Name: 'datum', Value:}]",-->
                    </div>
                </div>
        </div>
        </div>
            <div class="row">
            <!-- Količina -->
                <div class="col-lg-2 col-12">
                    <div class="form-group row">
                        <div class="col-md-12">
                            <yt-number-input-v3
                                name="txtKolicina"                                 
                                [Label]="'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR'" 
                                formControlName="Kolicina"
                                (OnBlur)="onCenaSelect()">
                            </yt-number-input-v3>
                            <div class="form-error" *ngIf="submitted && fc.Kolicina.invalid">
                                <span *ngFor="let validation of errorMessages.Kolicina">
                                  <span class="error-message" *ngIf="fc.Kolicina.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                              </span>
                            </div>
                             <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                                <span class="error-message"
                                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlKolicina && !this.baseFormGroup.errors.checkControlKolicina.valid"><span
                                    translate="{{this.baseFormGroup.errors.checkControlKolicina.message}}"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Jedinica mere-->
                <div class="col-lg-1 col-12">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-dropdown-picklist 
                          [ModelName]="'jedinicamere'" 
                          [GetName]="'get'" 
                          [ModelProperty]="'Oznaka'" 
                          [OrderBy]="'Naziv'"
                          [AllowAddNew]="false" 
                          formControlName="JedinicaMereID" 
                          [Label]="'FAKDOKUMENTSTAVKA.JM.SINGULAR'"
                          [Width]="'600px'"
                          [ngClass]="{'is-invalid': submitted && fc.JedinicaMereID.invalid}">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.JedinicaMereID.invalid">
                            <span *ngFor="let validation of errorMessages.JedinicaMereID">
                              <span class="error-message" *ngIf="fc.JedinicaMereID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- Cena -->
                <div class="col-lg-2 col-12" *ngIf="fcd && fcd['CenaUValuti'] && !fcd['CenaUValuti'].IsVisible">
                    <div class="form-group row">                       
                        <div class="col-md-12">
                            <yt-number-input-v3
                                name="txtCena" 
                                [Label]="'FAKDOKUMENTSTAVKA.CENA.SINGULAR'" 
                                formControlName="Cena"
                                (OnBlur)="onCenaSelect()"
                                #niv3Cena
                                [FormatString]="'1.7-7'">
                            </yt-number-input-v3>
                            <div class="form-error" *ngIf="submitted && fc.Cena.invalid">
                                <span *ngFor="let validation of errorMessages.Cena">
                                    <span class="error-message" *ngIf="fc.Cena.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>  

<!-- {{fc.VrednostPreRabataStavke.value}} -->


            <!-- Cena u valuti -->
            <div class="col-lg-2 col-12" *ngIf="fcd && fcd['CenaUValuti'] && fcd['CenaUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtCenaUValuti" 
                            [Label]="'FAKDOKUMENTSTAVKAIZVOZ.CENAUVALUTI.SINGULAR'" 
                            formControlName="CenaUValuti"
                            #niv3CenaUValuti
                            [FormatString]="'1.7-7'"
                            (OnBlur)="onCenaUValutiSelect()">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.Cena.invalid">
                            <span *ngFor="let validation of errorMessages.Cena">
                              <span class="error-message" *ngIf="fc.Cena.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                    </div>
                </div>
            </div>  

            <!-- Rabat_proc za dinarske kontrola-->  
            <div class="col-lg-3 col-12" *ngIf="fcd && fcd['Rabat'] && fcd['Rabat'].IsVisible">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-rebate-switch
                                      (OnChange)="onRebateChange($event)"
                                      formControlName="Rabat"
                                      [Vrednost]="baseFormGroup.get('Cena') != null ? baseFormGroup.get('Cena').value : 0"
                                      [Label1]="'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR'"
                                      [Label2]="'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR'">

                    </yt-rebate-switch>
                    <div class="form-error" *ngIf="submitted && fc.RabatProc.invalid">
                      <span *ngFor="let validation of errorMessages.RabatProc">
                        <span class="error-message" *ngIf="fc.RabatProc.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
            </div>

            <!-- Rabat_proc_u_valuti-->  
            <div class="col-lg-3 col-12" *ngIf="fcd && fcd['RabatUValuti'] && fcd['RabatUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">                       
                        <yt-rebate-switch                            
                            (OnChange)="onRebateValutaChange($event)"
                            formControlName="RabatUValuti"
                            [Vrednost]="baseFormGroup.get('CenaUValuti') != null ? baseFormGroup.get('CenaUValuti').value : 0"
                            [Label1]="'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR'"
                            [Label2]="'FAKDOKUMENTSTAVKA.RABATVREDUVALUTI.SINGULAR'">
                        </yt-rebate-switch>
                    </div>
                </div>
            </div>

             <!-- Rabat % zbog izvoznih -->
             <!-- <div class="col-lg-1 col-12" *ngIf="fcd && fcd['RabatVredPoJmUValuti'] && fcd['RabatVredPoJmUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtRabatProcenat" 
                            [Label]="'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR'" 
                            formControlName="RabatProc"
                            (OnBlur)="onRabatProcChange()">
                        </yt-number-input-v3>
                        
                    </div>
                </div>
            </div>   -->
            

            <!-- 22.08.2023 -->

            <!-- <div class="col-lg-2 col-12" *ngIf="fcd && fcd['RabatVredPoJmUValuti'] && fcd['RabatVredPoJmUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtRabat" 
                            [Label]="'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR'" 
                            formControlName="RabatVred"
                            [disabled]="true">
                        </yt-number-input-v3>
                        
                    </div>
                </div>
            </div>   -->
<!-- {{fc.RabatStavke.value}} -->
<!-- {{fc.OsnovicaStavke.value}} -->
            <!-- Rabat valuta -->
            <!-- <div class="col-lg-2 col-12" *ngIf="fcd && fcd['RabatVredPoJmUValuti'] && fcd['RabatVredPoJmUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtRabatValuta" 
                            [Label]="'FAKDOKUMENTSTAVKAIZVOZ.RABATUVALUTI.SINGULAR'" 
                            formControlName="RabatVredPoJmUValuti"
                            (OnBlur)="onRabatuValutiChange()">
                        </yt-number-input-v3>
                        
                    </div>
                </div>
            </div>   -->

            <!-- Osnovica u valuti -->
            <div class="col-lg-2 col-12" *ngIf="fcd && fcd['CenaUValuti'] && fcd['CenaUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtOsnovicaUValuti" 
                            [Label]="'FAKDOKUMENTSTAVKAIZVOZ.OSNOVICAUVALUTI.SINGULAR'" 
                            formControlName="OsnovicaStavkeUValuti"
                            [disabled]="true">
                        </yt-number-input-v3>
                        
                    </div>
                </div>
            </div>  
<!-- {{fc.PdvStavke.value}} -->
<!-- {{fc.VrednostStavke.value}} -->
            <!-- Cena sa PDV -->

            <div class="col-lg-2 col-12" *ngIf="fcd && fcd['CenaSaPDV'] && fcd['CenaSaPDV'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtCenaSaPDV" 
                            [Label]="'FAKDOKUMENTSTAVKA.CENASAPDV.SINGULAR'" 
                            formControlName="CenaSaPDV"
                            >
                            <!-- (OnChange)="onCenaSaPdvSelect()"> -->
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>  
            <!-- Osnovica -->
            <div class="col-lg-2 col-12" *ngIf="fcd && fcd['OsnovicaStavke'] && fcd['OsnovicaStavke'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtOsnovica" 
                            [Label]="'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR'" 
                            formControlName="OsnovicaStavke"
                            
                            >
                        </yt-number-input-v3>
                        <!-- <div class="form-error" *ngIf="submitted && fc.Osnovica.invalid">
                            <span *ngFor="let validation of errorMessages.Osnovica">
                                <span class="error-message" *ngIf="fc.Osnovica.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div> -->
                    </div>
                </div>
            </div>  
        </div>
        <div class="row" *ngIf="fcd && fcd['CenaUValuti'] && fcd['CenaUValuti'].IsVisible">
            <div class="col-lg-2 col-12"></div>
            <div class="col-lg-1 col-12"></div>
            <div class="col-lg-2 col-12" >
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtCena" 
                            [Label]="'FAKDOKUMENTSTAVKA.CENA.SINGULAR'" 
                            formControlName="Cena"
                            (OnBlur)="onCenaSelect()"
                            #niv3CenaIno
                            [FormatString]="'1.7-7'"
                            >

<!-- 22.08.2023 -->

                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.Cena.invalid">
                            <span *ngFor="let validation of errorMessages.Cena">
                                <span class="error-message" *ngIf="fc.Cena.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div> 
            <!--   -->
            <!-- <div class="col-lg-1 col-12"></div>  -->
            <!-- Rabat dinari -->
            <div class="col-lg-3 col-12" *ngIf="fcd && fcd['RabatVredUValuti'] && fcd['RabatVredUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-5"></div>
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                        <yt-number-input-v3
                            name="txtRabat" 
                            [Label]="'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR'" 
                            formControlName="RabatVred"
                            [disabled]="true">
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>  
             <!-- Osnovica -->
             <div class="col-lg-2 col-12" *ngIf="fcd && fcd['CenaUValuti'] && fcd['CenaUValuti'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtOsnovica" 
                            [Label]="'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR'" 
                            formControlName="OsnovicaStavke"
                            [disabled]="true"
                            >
                        </yt-number-input-v3>                        
                    </div>
                </div>
            </div>  
        </div>
        <div class="row">
            <div class="col-lg-2 col-12"  *ngIf="fcd && fcd['IdentifikatorKlasifikacije'] && fcd['IdentifikatorKlasifikacije'].IsVisible">
                <div class="form-group row">
                    <div class="col-md-12">                     
                        <yt-dropdown-picklist 
                        [ModelName]="'commonString'"                          
                        [ModelProperty]="'Name'"                  
                        formControlName="IdentifikatorKlasifikacije"                                                 
                        [Position]="'left'"
                        [AllowAddNew]="false" 
                        [Source]="identifikatorKlasifikacije"
                        [Label]="'FAKDOKUMENTSTAVKA.IDENTIFIKATORKLASIFIKACIJE.SINGULAR'"
                        [Required]="false">
                      </yt-dropdown-picklist >    
                       
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-2 col-12" >
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtRabatProc" 
                            [Label]="'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR'" 
                            formControlName="RabatProc"
                            >
                        </yt-number-input-v3>                        
                    </div>
                </div>
            </div>  
            <div class="col-lg-2 col-12" >
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtRabatVred" 
                            [Label]="'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR'" 
                            formControlName="RabatVred"
                            >
                        </yt-number-input-v3>                        
                    </div>
                </div>
            </div>  
        </div> -->
    </form>
</div>
